export default __webpack_public_path__ + "static/media/figure-triangle-4.24889863.svg";